<template>
  <div class="hireExpert">
    <mt-header title="雇佣专家">
      <mt-button slot="left" icon="back" @click.native="$router.go(-1)"></mt-button>
      <!-- <mt-button slot="right">雇佣</mt-button> -->
    </mt-header>
    <div class="content">
      <h1>确认雇佣，支付项目金额到平台担保</h1>
      <div class="portrait" @click="toPersonDetail(accountId)">
        <img :src="data.photoUrl">
        <p>{{data.userName}}</p>
        <!-- <span>{{data.title}}</span> -->
      </div>
      <!-- <div class="name" @click="showProjectList">
        <span>{{selectProject}}</span>
        <div class="triangle"></div>
      </div> -->
      <div class="money_wrap">
        <p>最终协商价格<span style="color:red;font-weight:bold">*</span></p>
        <div>
          <input type="number" v-model="money" oninput="if(value.length>7)value=value.slice(0,7)"  @input="moneyChange" placeholder="与专家协商后的项目总价格">
          <label for="money" style="float: right;">元</label>
        </div>
      </div>
      <div v-show="showMoneyError" class="help is-danger">{{moneyError}}</div>
      <div class="finalMoney">
        <span>项目预算为{{budgetSpan}}</span>
      </div>
      <div class="time">
        <p>日期<span style="color:red;font-weight:bold">*</span></p>
        <div class="timeall">
          <div class="starTime">
            <!-- <div @click="startShow">
              <span>{{startValue}}</span>
              <div class="triangle"></div>
            </div> -->
            <input type="text" class="timeOneStart" v-model="startValue" placeholder="开工日期" @click="startShow" readonly="readonly">
          </div>
          至
          <div class="overTime">
            <!-- <div @click="overShow">
              <span>{{overValue}}</span>
              <div class="triangle"></div>
            </div> -->
            <input type="text" class="timeOneStart" v-model="overValue" placeholder="交付日期" @click="overShow" readonly="readonly">
          </div>
        </div>
      </div>
      <div class="finalMoney">
        <span>协商的项目开工日期和结束日期</span>
      </div>
      <!-- <div class="cost">
        <p class="cost_title">平台服务费</p>
        <p><span v-if="money">{{money}}元</span><span>项目总额*{{costRate}}%</span> = <strong>¥{{feeMoney}}</strong></p>
      </div> -->
      <div class="contract">
        <p>合同签署方式<span style="color:red;font-weight:bold">*</span></p>
        <div>
          <input type="radio" name="type" v-model="contractValue" value="0">
            <label for='radio'>
              签署平台默认电子合同 <span @click="showcontract">《云智图三方服务合同》</span>
            </label>
        </div>
        <div>
          <input type="radio" name="type" v-model="contractValue" value="1">
            <label for='radio'>
              需修订合同内容，签署纸质合同（项目管家会和您联系签署）
            </label>
        </div>
      </div>
    </div>
    <div class="btn" @click="showPay">确认雇佣，支付到平台担保（￥{{allMoney}}）</div>
    <!-- 项目列表 -->
    <mt-popup v-model="projectPopup" position="bottom" class="popup" :closeOnClickModal=false style="width:100%;">
      <div class="picker-toolbar">
        <span class="cancel" @click="hidenProjectList">取消</span>
        <span class="confirm" @click="confirmProject">确定</span>
      </div>
      <mt-picker class="pickerWrap" :slots="projectSlots" value-key="title" @change="onProjectChange" :visible-item-count="3"></mt-picker>
    </mt-popup>
    <!-- 三方服务合同 -->
    <mt-popup v-model="contractPopup" position="right" class="popup" style="width:100%; height:100%; overflow-y:auto;">
      <mt-header title="云智图三方服务合同">
        <mt-button slot="left" icon="back" @click.native="hidencontract">返回</mt-button>
      </mt-header>
      <pre ref='contract' class="contract"></pre>
    </mt-popup>
    <!-- 开始时间 -->
    <mt-datetime-picker ref="startpicker" type="date" :startDate="nowTime" :endDate="endTime" @confirm="showStartValue"></mt-datetime-picker>
    <!-- 结束时间 -->
    <mt-datetime-picker ref="overpicker" type="date" :startDate="nowTime" :endDate="endTime" @confirm="showOverValue"></mt-datetime-picker>
    <!-- 支付 -->
    <mt-popup v-model="payPopup" class="payPopup" :closeOnClickModal='false' >
      <div class="payTitle">
        <icon name='credit-card'></icon>
        <p>请选择支付方式</p>
      </div>
      <div class="payType">
        <div>
          <label for="zfb"><img src="../assets/img/hireExpert/zfb.png"><span>支付宝支付</span></label><input type="radio" name="paytype" v-model="payValue" value="alipay">
        </div>
        <div>
          <label for="wx"><img src="../assets/img/hireExpert/wx.png"><span>微信支付</span></label><input type="radio" name="paytype" v-model="payValue" value="wecahtpay">
        </div>
      </div>
      <div class="payBtn">
        <button @click="hidenPay">取消</button>
        <button @click="payMoney">确认支付</button>
      </div>
    </mt-popup>
    <!-- 支付成功弹框 -->
    <mt-popup v-model="moneysuccess" position="right" class="moneypopup" >
      <div class="moneypopupbox">
        <div class="popupbox">
          <h1 ><icon name='check-circle' size="big" style="margin-right:10px;"></icon>支付成功</h1>
          <p>您的项目已将资金托管到平台，我们将通知您雇佣的专家该项目已担保，您可以和专家沟通工作进度。</p>
          <div class="btns" >
            <button @click="gohome" >返回首页</button>
            <button @click="seeprojectdetail">查看项目详情</button>
          </div>
        </div>
      </div>
    </mt-popup>
    <!-- 等待支付弹框 -->
    <mt-popup v-model="waitmoney" position="right" class="moneypopup">
      <div class="moneypopupbox">
        <div class="popupbox">
          <h1><icon name='check-circle' size="big" style="margin-right:10px;"></icon>等待支付结果</h1>
          <p>请求超时，请等待支付结果</p>
          <div class="btns">
            <button @click="gohome">返回首页</button>
            <button @click="seeprojectdetail">查看项目详情</button>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import {formatDate} from '../assets/js/date.js'
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'hireExpert',
  data () {
    return {
      projectPopup: false,
      projectSlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center',
          defaultIndex: 0
        }
      ],
      selectProject: '',
      selectProjectId: this.$route.query.projectId,
      selectProjectTmp: '',
      contractPopup: false,
      startValue: '',
      overValue: '',
      payPopup: false,
      accountId: this.$route.query.id,
      projectId: this.$route.query.projectId,
      // 初始化数据
      data: '',
      // 项目预算
      budgetSpan: '',
      // 项目费用
      money: '',
      showMoneyError: false,
      showTimeError: false,
      // 费率
      costRate: 0,
      // 总额
      allMoney: 0,
      // 费用
      feeMoney: 0,
      // 合同选择值
      contractValue: 0,
      // 支付方式
      payValue: 'alipay',
      // 输入金额错误信息
      moneyError: '请输入为正整数的有效金额',
      nowTime: new Date(),
      endTime: new Date(new Date().getFullYear() + 2, 11, 31),
      // 支付成功弹框
      moneysuccess: false,
      // 等待支付弹框
      waitmoney: false,
      orderno: this.$route.query.orderno,
      time: '0',
      spliturl:'',
      url:'',
      charsetindex:'',
      loginIdindex:'',
      loginId:''
    }
  },
  mounted () {
    // if (this.$route.query.project !== undefined && this.$route.query.project !== '') {
    //   this.selectProject = this.$route.query.project.title
    //   this.selectProjectId = this.$route.query.project.id
    // }else {
    //   this.selectProjectId = this.$route.query.projectId
    // }
    if(this.$route.query.projectTitle){
      this.selectProject=this.$route.query.projectTitle
      localStorage.setItem('selectProject',this.$route.query.projectTitle)
    }else{
      this.selectProject=localStorage.getItem('selectProject')
    }
    if(this.STATE.state.loginId){
      this.loginId = this.STATE.state.loginId
    }
    if(this.orderno !== 'urdefined' && this.orderno !== null && this.orderno !== undefined){
      this.selectProjectId = this.$route.query.projectId
      this.loginId = this.$route.query.loginId
      Indicator.open({
        text: '查询支付结果...',
        spinnerType: 'fading-circle'
      })
      this.time = 0
      this.runCheck()
      // this.checkPayResult()
    } else {
      this.loadSelect()
      this.STATE.commit('checkState', this.STATE.state)
      this.STATE.commit('setHistory', this.STATE.state)
      // this.runCheck()
    }
  },
  methods: {
    gohome: function() {
      this.$router.push('/')
    },
    seeprojectdetail: function() {
      this.$router.push({name: 'myProjectDetail', params: { projectId: this.selectProjectId,loginId: this.loginId }})
    },
    runCheck: function () {
      if (this.time > 5) {
        Indicator.close()
        this.loadSelect()
      } else {
        if (this.time%5 === 0) {
          this.checkPayResult()
        }
        if (!this.moneysuccess) {
          this.time ++
          setTimeout(this.runCheck, 1000)
        }
      }
    },
    checkPayResult: function () {
      let _this = this
      this.axios.get('url/fund/finishpay?orderno='+this.orderno).then(function (res) {
        _this.payValue='alipay'
        if(res.data.success === true){
          Indicator.close()
          _this.moneysuccess = true
        }
      }).catch(function (response) {
        console.log('finishpay接口失败')
      })
    },
    loadSelect: function () {
      let _this = this
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      this.axios.all([this.HireExpert(), this.getBudget(), this.getCostRate()]).then(this.axios.spread((res1, res2, res3) => {
        Indicator.close()
        _this.data = res1.data
        _this.projectSlots[0].values = res1.data.projects
        _this.budgetSpan = res2.data.msg
        _this.costRate = Math.round((res3.data.data * 100))
      })).catch(function (response) {
        Indicator.close()
      })
    },
    showProjectList: function () {
      this.projectPopup = true
    },
    getCostRate: function () {
      return this.axios.get('url/fund/serviceFeeRate?projectId=' + this.selectProjectId)
    },
    HireExpert: function () {
      return this.axios.get('url/weixinHireExpert?id=' + this.accountId + '&loginId=' + this.loginId)
    },
    getBudget: function () {
      return this.axios.get('url/work/project/budget?projectId=' + this.selectProjectId)
    },
    chooseGetBudget: function (projectId) {
      let _this = this
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      this.axios.get('url/work/project/budget?projectId=' + projectId).then(function (res) {
        Indicator.close()
        _this.budgetSpan = res.data.msg
      }).catch(function (response) {
        Indicator.close()
      })
    },
    hidenProjectList: function () {
      this.projectPopup = false
    },
    confirmProject: function () {
      this.projectPopup = false
      this.selectProject = this.selectProjectTmp.title
      this.selectProjectId = this.selectProjectTmp.id
      this.chooseGetBudget(this.selectProjectId)
    },
    onProjectChange: function (picker, values) {
      this.selectProjectTmp = values[0]
    },
    showcontract: function () {
      this.contractPopup = true
      this.handleClick()
    },
    hidencontract: function () {
      this.contractPopup = false
    },
    startShow: function () {
      this.$refs.startpicker.open()
    },
    showStartValue: function (value) {
      var date = new Date(value)
      var datetmp = formatDate(date, 'yyyy-MM-dd')
      date = new Date(datetmp)
      var endDate = new Date(this.overValue)
      var nowDate = new Date()
      if (nowDate > date + 1) {
        Toast({
          message: '开工日期不能小于今日',
          position: 'middle',
          duration: 1000
        })
        return
      }
      if (date > endDate) {
        Toast({
          message: '开工日期不能在交付日期之后',
          position: 'middle',
          duration: 1000
        })
        this.startValue = this.overValue
      } else {
        this.showTimeError = false
        this.startValue = formatDate(date, 'yyyy-MM-dd')
      }
    },
    overShow: function () {
      this.$refs.overpicker.open()
    },
    showOverValue: function (value) {
      var date = new Date(value)
      var datetmp = formatDate(date, 'yyyy-MM-dd')
      date = new Date(datetmp)
      var startDate = new Date(this.startValue)
      if (date < startDate) {
        Toast({
          message: '交付日期不能在开工日期之前',
          position: 'middle',
          duration: 1000
        })
        this.overValue = this.startValue
      } else {
        this.showTimeError = false
        this.overValue = formatDate(date, 'yyyy-MM-dd')
      }
    },
    showPay: function () {
      var moneyOk = false
      var startTimeOk = false
      var overTimeOk = false
      if (this.judgeMoney()) {
        this.showMoneyError = true
        moneyOk = false
        return
      } else {
        this.showMoneyError = false
        moneyOk = true
      }
      if (this.startValue.length <= 0) {
        Toast({
          message: '请选择开工日期',
          position: 'middle',
          duration: 1000
        })
        startTimeOk = false
        return
      } else {
        startTimeOk = true
      }
      if (this.overValue.length <= 0) {
        Toast({
          message: '请选择交付日期',
          position: 'middle',
          duration: 1000
        })
        overTimeOk = false
        return
      } else {
        overTimeOk = true
      }
      if (moneyOk && startTimeOk && overTimeOk) {
        this.payPopup = true
      }
    },
    hidenPay: function () {
      this.payPopup = false
    },
    back: function () {
      this.$router.go(-1)
    },
    moneyChange: function () {
      // if (this.money === '0') {
      //   this.money = '1'
      // }
      // var reg = /^[0-9]*[1-9][0-9]*$/
      // var bol = reg.test(this.money)
      // var bol2 = false
      // if (this.money.length > 0 && this.money.length <= 7) {
      //   bol2 = true
      // } else if (this.money.length <= 0) {
      //   this.moneyError = '请输入项目金额'
      // } else {
      //   this.moneyError = '请输入为正整数的有效金额'
      // }
      // if (bol && bol2) {
      //   this.showMoneyError = false
      //   this.feeMoney = parseInt(this.money * this.costRate / 100)
      //   this.allMoney = parseInt(this.money) + parseInt(this.feeMoney)
      // } else {
      //   this.showMoneyError = true
      // }
      if (this.judgeMoney()) {
        this.showMoneyError = true
      } else {
        this.showMoneyError = false
      }
      this.feeMoney = parseInt(this.money) * this.costRate / 100
      if (isNaN(this.feeMoney)) {
        this.feeMoney = 0
      }
      this.feeMoney = this.feeMoney.toFixed(0)


// 修改需求方要支付的金额
      // this.allMoney = parseInt(this.money) + parseInt(this.feeMoney)
      this.allMoney = parseInt(this.money)
      

      if (isNaN(this.allMoney)) {
        this.allMoney = 0
      }
    },
    judgeMoney: function () {
      if (this.money === '0') {
        this.money = '1'
      }
      var reg = /^[0-9]*[1-9][0-9]*$/
      var bol = reg.test(this.money)
      var bol2 = false
      if (this.money.length > 0 && this.money.length <= 7) {
        bol2 = true
      } else if (this.money.length <= 0) {
        this.moneyError = '请输入项目金额'
      } else {
        // this.moneyError = '请输入为正整数的有效金额'
      }
      if (bol && bol2) {
        return false
      } else {
        return true
      }
    },
    handleClick: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: 'http://blog.yunzhitu.com/contract/feed/json',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        _this.contractPopup = true
        _this.$refs.contract.innerHTML = res.data.items[0].content_html
      })
    },
    onBridgeReady: function (data,loginId) {
      let _this = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': data.appId,
          'timeStamp': data.timeStamp,
          'nonceStr': data.nonceStr,
          'package': data.package,
          'signType': data.signType,
          'paySign': data.paySign
        },
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            _this.$router.push({path: '/project/hireExpert', query: { id: _this.accountId, projectId: _this.projectId,  orderno: data.orderno, loginId:loginId, }})
          } else {
            Toast({
              message: '微信支付失败',
              position: 'top',
              duration: 1000
            })
          }
        }
      )
    },
    payMoney: function () {
      if (this.payValue === '') {
        Toast({
          message: '请选择支付方式',
          position: 'top',
          duration: 1000
        })
        return false
      }
      window.localStorage.setItem('supplierId', this.accountId)
      let channelType = 6
      if (this.payValue === 'alipay') {
        this.payBywechatH5AndAlipay(channelType)
      } else {
        channelType = 8
        if (typeof WeixinJSBridge === 'undefined') {
          this.payBywechatH5AndAlipay(channelType)
        } else {
          this.payBywechatJSAPI(channelType)
        }
      }
    },
    payBywechatJSAPI: function (channelType) {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/fund/wechatBrowserCharge',
        params: {
          contractType: this.contractValue,
          channelType: channelType,

          amount: this.money,

          serviceFee: this.feeMoney,
          projectId: this.selectProjectId,
          startDateStr: this.startValue,
          endDateStr: this.overValue,
          supplierId: this.accountId,
          loginId: this.STATE.state.loginId,
          wechatCode: this.STATE.state.wechatCode,
          subject: '云智图『' + this.selectProject + '』担保金',
          body: '云智图平台『' + this.selectProject + '』的项目担保相关费用总额'
        }
      }).then(function (response) {
        if (response.data.success === true) {
          _this.onBridgeReady(response.data.data,_this.STATE.state.loginId)
        } else {
          Toast({
            message: response.data.msg,
            position: 'top',
            duration: 1000
          })
        }
      }).catch(function (response) {
        Toast({
          message: '网络异常',
          position: 'top',
          duration: 1000
        })
      })
    },
    payBywechatH5AndAlipay: function (channelType) {
      this.axios({
        method: 'get',
        url: '/url/fund/wechatCharge',
        params: {
          contractType: this.contractValue,
          channelType: channelType,

          amount: this.money,

          serviceFee: this.feeMoney,
          projectId: this.selectProjectId,
          startDateStr: this.startValue,
          endDateStr: this.overValue,
          supplierId: this.accountId,
          loginId: this.STATE.state.loginId,
          subject: '云智图『' + this.selectProject + '』担保金',
          body: '云智图平台『' + this.selectProject + '』的项目担保相关费用总额'
        }
      }).then(function (response) {
        if (response.data.success === true) {
          if (channelType === 6) {
            const div = document.createElement('div')
            div.innerHTML = response.data.data
            document.body.appendChild(div)
            document.forms[0].submit()
          } else {
            if (response.data.data.hasOwnProperty('mwebUrl') && response.data.data.mwebUrl !== null && response.data.data.mwebUrl !== undefined) {
              let tourl = response.data.data.mwebUrl + '&redirect_url=' + response.data.data.redirectUrl
              window.location.href = tourl
            }
          }
        } else {
          Toast({
            message: response.data.msg,
            position: 'top',
            duration: 1000
          })
        }
      }).catch(function (response) {
        Toast({
          message: '网络异常',
          position: 'top',
          duration: 1000
        })
      })
    },
    toPersonDetail (account) {
      this.$router.push({path: '/myDetail', query: { id: account }})
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    }
  }
}
</script>

<style scoped>
 .content{
   padding: 20px 13px 15px;
 }
 h1{
   text-align:center;
   font-size: 17px;
   font-weight: bold;
 }
 .portrait{
   text-align: center;
   margin: 30px 0 15px;
 }
 .portrait img{
   width: 70px;
   height: 70px;
   border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
  -ms-border-radius:50%;
  -o-border-radius:50%;
 }
 .portrait p{
   font-size: 14px;
   color: #108ee9;
   margin-top: 10px;
 }
 .portrait span{
   font-size: 12px;
   color: #727272;
   display: block;
 }
 .name{
   line-height: 40px;
   height: 40px;
   text-align: center;
   position: relative;
   border-bottom: 1px solid #000;
 }
 .triangle{
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #000;
  position: absolute!important;
  right: 10px;
  top: 17px;
}
.money_wrap{
  display: table;
  width: 100%;
  margin: 10px 0;
}
.money_wrap p{
  display: table-cell;
  font-size: 12px;
  width: 90px;
}
.money_wrap div{
  display: table-cell;
  border-bottom: 1px solid #000;
}
.money_wrap div input{
  font-size: 14px;
  width: 90%;
  margin-bottom: 2px;
  vertical-align: bottom;
  text-align: center;
  outline: none;
  border: 0;
}
.finalMoney{
  margin: 10px 0;
  /* text-align: center; */
}
.finalMoney span{
  font-size: 12px;
  color: #727272;
  display: inline-block;
  /* margin: 0 10px; */
}
.time{
  margin:10px 0;
  overflow: hidden;
  width: 100%;
  display: table;
}
.time p{
  display: table-cell;
  width: 40px;
  font-size: 12px;
}
.time .timeall{
  display:table;
  width:100%;
  vertical-align:middle;
  text-align:center;
}
.starTime,.overTime{
  float: left;
  width: 45%;
  /* border-bottom:1px solid #000; */
}
.starTime .timeOneStart{
  width: 100%;
  border-bottom: 1px solid #000;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  text-align:center;
}
.overTime{
  /* margin-left: 10%; */
  float:right;
}
.overTime .timeOneStart{
  width: 100%;
  border-bottom: 1px solid #000;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  text-align: center;
}
input::-ms-input-placeholder{
  text-align: center;
}
input::-webkit-input-placeholder{
  text-align: center;
}
.starTime p,.overTime p{
  font-size: 12px;
}
.starTime div,.overTime div{
  position: relative;
  height: 22px;
  line-height: 22px;
}
.starTime div .triangle,.overTime div .triangle{
    top: 9px;
    right: 0;
}
.starTime div span,.overTime div span{
  font-size: 14px;
}
.cost{
  margin: 10px 0;
  display:table;
  width:100%;
}
.cost p{
  font-size: 12px;
  display:table-cell;
}
.cost .cost_title{
  width:30%;
}
.cost p:nth-child(2){
  text-align:right;
  margin:10px 0;
  color: #727272;
  width:70%;
}
.cost p strong{
  font-size: 17px;
  color: #000;
  font-weight: bold;
}
.contract{
  margin: 10px 0;
}
.contract p{
  font-size: 12px;
}
.contract input{
  vertical-align: middle;
}
.contract label{
  font-size: 12px;
  color: #777;
  margin-left: 5px;
  vertical-align: middle;
}
.contract label span{
  color: #45a0ec;
  text-decoration: underline;
}
.btn{
  font-size: 14px;
  margin-bottom: 70px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  background-color: #108ee9;
}
.picker-toolbar{
  padding: 6px;
  overflow:hidden;
}
.cancel{
  float:left;
  font-size:12px;
  padding:5px 10px;
  border:1px solid #ccc;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.confirm{
  float:right;
  font-size:12px;
  padding:5px 10px;
  color:#fff;
  border:1px solid #007aff;
  background-color:#007aff;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
pre{
  padding: 10px 15px;
}
.payPopup{
  border-radius:5px;
  -webkit-border-radius:5px;
  -moz-border-radius:5px;
  width: 90%;
}
.payTitle{
  text-align: center;
  border-bottom: 1px solid #bababa;
  padding-top: 5px;
}
.payTitle .fa-icon{
  transform: scale(2.5);
  margin: 18px 0 10px;
}
.payTitle p{
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 18px;
}
.payType div{
  border-bottom: 1px solid #d9d9d9;
  line-height: 43px;
  padding:0 10%;
}
.payType div img{
  width: 33px;
  vertical-align: middle;
}
.payType div span{
  font-size: 16px;
  color: #007bfe;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.payType div input{
  float: right;
  margin-top: 15px;
}
.payBtn{
  overflow: hidden;
}
.payBtn button{
  float: left;
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  color: #007bfe;
  border: none;
  outline: none;
  background-color: #fff;
}
.payBtn button:nth-child(1){
  border-right: 1px solid #d9d9d9;
  border-bottom-left-radius: 5px;
  -webkit-border-bottom-left-radius: 5px;
  -moz-border-bottom-left-radius: 5px;
}
.payBtn button:nth-child(2){
  border-right: 1px solid #d9d9d9;
  border-bottom-right-radius: 5px;
  -webkit-border-bottom-right-radius: 5px;
  -moz-border-bottom-right-radius: 5px;
}
.help{
  display:block;
  width:80%;
  margin:0 auto;
  font-size:14px;
  color:red;
  text-align:center
}
.moneypopup{
  width:100%;
  height:100%;
}
.moneypopup .moneypopupbox{
  /* height:220px; */
  background:#02a7f0;
  color:#fff;
}
.moneypopup .moneypopupbox .popupbox{
  padding:0 30px;
  text-align:center;
}
.moneypopup div h1{
  padding:40px 0 15px 0; 
}
.moneypopup div .btns{
  padding-top:25px;
  width:100%;
  display:flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom:40px;
}
.moneypopup div .btns button{
  border:1px solid #ddd;
  background:#02a7f0;
  border-radius:3px;
  font-size: 14px;
  padding: 5px 15px;
}
.mint-indicator-wrapper {
  z-index: 1000 !important;
}

.mint-indicator-mask {
  z-index: 1000 !important;
}
</style>



// WEBPACK FOOTER //
// hireExpert.vue?5018de5b